import { gql } from '@apollo/client';

export const COURSES = gql`
  query Courses(
    $page: Int
    $limit: Int
    $searchValue: String
    $categoryId: ID
    $category: String
    $ids: [String]
    $kind: String
    $status: Status
    $featured: Boolean
  ) {
    courses(
      page: $page
      limit: $limit
      searchValue: $searchValue
      categoryId: $categoryId
      category: $category
      ids: $ids
      kind: $kind
      status: $status
      featured: $featured
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        currentPage
        totalPages
      }
      nodes {
        id
        title
        description
        price
        accessType
        thumbnail

        category {
          name
        }
        duration
        favouriteCount
        featured
        createdAt
      }
    }
  }
`;

export const GET_COURSE = gql`
  query Course($id: ID!) {
    course(id: $id) {
      id
      title
      description
      price
      accessType
      videoUrl
      thumbnail
      duration
      favouriteCount
      featured
      createdAt
      instructor {
        id
        name
        email
      }
      category {
        id
        name
        slug
      }
    }
  }
`;



export const PRODUCTS = gql`
  query PublicProducts(
    $searchValue: String
    $featured: Boolean
    $latest: Boolean
    $page: Int
    $limit: Int
    $skinType: SkinType
    $productLine: ProductLine
    $productType: ProductType
    $sort: SortInput
  ) {
    publicProducts(
      searchValue: $searchValue
      featured: $featured
      latest: $latest
      page: $page
      limit: $limit
      skinType: $skinType
      productLine: $productLine
      productType: $productType
      sort: $sort
    ) {
      id
      name
      code
      thumbnail
      images
      video
      attachment
      price
      discountPrice
      discount
      description
      ingredients
      favorite
      skinTypes
      productLines
      productTypes
      status
    }
  }
`;